import Vue from "vue"
import mountBusiness from "./mount"

export default () => {
  mountBusiness(Vue, {
    id: "business_app"
  })
}
